/**
 * Yetkili görsel: sohbet ekleri kimlik başlığı ister, <img src> bunu gönderemez. İçerik bir kez
 * indirilip blob adresine çevrilir ve sayfa boyunca önbellekte tutulur.
 */
import { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';
import { chatApi } from '../api/chatApi';
import { cn } from '@/shared/lib/cn';

const cache = new Map<string, Promise<string>>();

export function attachmentObjectUrl(url: string): Promise<string> {
  let p = cache.get(url);
  if (!p) {
    p = chatApi.attachmentBlob(url).then((b) => URL.createObjectURL(b));
    p.catch(() => cache.delete(url));
    cache.set(url, p);
  }
  return p;
}

export function AuthImage({ url, alt, className, onClick }: { url: string; alt: string; className?: string; onClick?: () => void }) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    attachmentObjectUrl(url).then(
      (s) => alive && setSrc(s),
      () => alive && setFailed(true),
    );
    return () => {
      alive = false;
    };
  }, [url]);
  if (failed)
    return (
      <span className={cn('bg-bg-muted text-fg-subtle flex items-center justify-center', className)}>
        <ImageOff className="h-5 w-5" />
      </span>
    );
  if (!src) return <span className={cn('bg-bg-muted animate-pulse', className)} />;
  return (
    <img
      src={src}
      alt={alt}
      onClick={onClick}
      className={cn('cursor-zoom-in object-cover', className)}
      loading="lazy"
      draggable={false}
    />
  );
}

/** Eki indirir (dosya adıyla). */
export async function downloadAttachment(url: string, fileName: string) {
  const href = await attachmentObjectUrl(url);
  const a = document.createElement('a');
  a.href = href;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
